export * from './mixin.component.style';
